// import { ValidateCheckbox } from "@/Checkbox";
// import DateButton from "@/common/DateButton";
// import { ValidateServiceCard } from "@/common/ServiceCard";
import { Divider } from "@/Divider";
import MessageModal from "@/MessageModal";
import { useEffect, useState, type ReactNode } from "react";
import { useForm } from "react-hook-form";
import useOpenModal from "^/common/useOpenModal";
import { CalendarNew as CalendarComponent } from "@/CalendarNew";
// import { Button } from "@/Button";
import { formatDate } from "%/date";
// import { ValidateSelectList } from "@/SelectList";
import {
  useCalculateCoin,
  // useHasBalanceCoin,
  useUpdateTempReserve,
  useUserReserve,
  // useUpdateUserReserve,
  // useCancelUserReserve,
} from "~/services/reservation";
import { PetDataType } from "~/types/common";
import { Dialog } from "@/Dialog";
import ContractModal from "@/common/ContractModal";
import { useRouter } from "@tanstack/react-router";

interface SelectList {
  value: string;
  label: string;
}
interface ReservationClassState {
  storeName: string;
  storeType: string;
  services: string;
  animal: string;
  agree: boolean;
  startDate: string | null;
  startHour: SelectList | null;
  endHour: SelectList | null;
  startMinute: SelectList | null;
  endMinute: SelectList | null;
}

const ReservationChgDaycare = ({
  storeName,
  storeType,
  storeData,
  petList,
  initialReservationSeq,
}: {
  storeName: string;
  storeType: string;
  storeData: {
    value: string;
    label: string;
  };
  petList: PetDataType[];
  initialReservationSeq?: number;
}) => {
  const { history } = useRouter();
  const {
    // handleSubmit,
    // control,
    // formState: { isValid, errors },
    setValue,
    watch,
  } = useForm<ReservationClassState>({
    defaultValues: {
      storeName: storeName,
      storeType: storeType,
      services: "",
      animal: "",
      startDate: null,
      startHour: null,
      endHour: null,
      startMinute: null,
      endMinute: null,
      agree: false,
    },
    mode: "onChange",
  });
  // const [ setDate] = useState(getToday());
  const { isOpenModal, closeModal } = useOpenModal();
  // const [isStart, setIsStart] = useState(false);
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [showContractDialog, setShowContractDialog] = useState(false);
  const [showContractModal, setShowContractModal] = useState(false);
  const [contractMessage] = useState("");
  const [showCoinShortageDialog, setShowCoinShortageDialog] = useState(false);
  const [showReservationCompleteDialog, setShowReservationCompleteDialog] =
    useState(false);
  const [showReservationCancelDialog, setShowReservationCancelDialog] =
    useState(false);
  const [reservationSeq, setReservationSeq] = useState<number | null>(null);
  const [isUpdatable, setIsUpdatable] = useState<boolean>(true);
  const [selectedPetSeq, setSelectedPetSeq] = useState<string | null>(
    petList && petList.length > 0 ? petList[0].petSeq.toString() : null
  );
  const [showGradeConfirmDialog, setShowGradeConfirmDialog] = useState(false);
  // const [gradeConfirm, setGradeConfirm] = useState(false); // 테스트를 위해 false로 설정

  // petList가 로드되면 첫 번째 반려동물을 자동으로 선택하고 폼 값도 설정
  useEffect(() => {
    if (petList && petList.length > 0) {
      const firstPetSeq = petList[0].petSeq.toString();
      setSelectedPetSeq(firstPetSeq);
      setValue("animal", firstPetSeq, { shouldValidate: true });
    }
  }, [petList, setValue]);

  const cdProductType = "PRODUCT_TYPE_DAYCARE";
  console.log(petList);
  // const { data: reserveForms } = useReserveForms(
  //   parseInt(storeData.value),
  //   selectedPetSeq ? Number(selectedPetSeq) : 0,
  //   cdProductType,
  //   !!selectedPetSeq
  // );
  // console.log(reserveForms);

  // 코인 계산 API 훅
  const { mutate: calculateCoin } = useCalculateCoin();

  // // 예약 생성 API 훅
  // const { mutate: updateReserve, isPending: isUpdating } =
  //   useUpdateUserReserve();

  // // 예약 취소 API 훅
  // const { mutate: cancelReserve, isPending: isCanceling } =
  //   useCancelUserReserve();

  // 임시 예약 업데이트 API 훅
  const { mutate: updateTempReserve } = useUpdateTempReserve();

  // 코인 잔액 확인 API 훅
  // const coinDiff = calculateCoinData?.data?.coinDiff || 0;
  // const { data: hasBalanceCoinData, isLoading: isCheckingBalance } =
  //   useHasBalanceCoin(coinDiff);

  // 기존 예약 정보 조회 API 훅
  const { data: existingReserveData } = useUserReserve({
    reservationSeq: initialReservationSeq || 0,
  });

  // 기존 예약 데이터를 폼 기본값으로 설정
  useEffect(() => {
    if (existingReserveData?.data) {
      const reserveData = existingReserveData.data;
      const reserveForm = reserveData.reserveForm;

      // 기본 폼 값 설정
      setValue("startDate", reserveForm.dtReservStart, {
        shouldValidate: true,
      });

      // state도 함께 설정
      setStartDate(new Date(reserveForm.dtReservStart));

      // 시간 설정 (시간과 분 분리)
      if (reserveForm.startTime) {
        const [hour, minute] = reserveForm.startTime.split(":");
        setValue(
          "startHour",
          { value: hour, label: hour },
          { shouldValidate: true }
        );
        setValue(
          "startMinute",
          { value: minute, label: minute },
          { shouldValidate: true }
        );
      }
      if (reserveForm.endTime) {
        const [hour, minute] = reserveForm.endTime.split(":");
        setValue(
          "endHour",
          { value: hour, label: hour },
          { shouldValidate: true }
        );
        setValue(
          "endMinute",
          { value: minute, label: minute },
          { shouldValidate: true }
        );
      }

      // 선택된 반려동물 설정
      const selectedPet = reserveForm.pets.find((pet: any) => pet.select);
      if (selectedPet) {
        setSelectedPetSeq(selectedPet.petSeq.toString());
        setValue("animal", selectedPet.petSeq.toString(), {
          shouldValidate: true,
        });
      }

      // 서비스 선택 설정
      const selectedServices = reserveForm.additionals
        .filter((service: any) => service.select)
        .map((service: any) => service.additionalCompanySeq.toString())
        .join(",");
      setValue("services", selectedServices, { shouldValidate: true });

      // reservationSeq 설정
      setReservationSeq(reserveData.reservationSeq);

      // updatable 상태 설정 ----예약수정 막기----
      // setIsUpdatable(reserveData.updatable);
      setIsUpdatable(false);
    }
  }, [existingReserveData, setValue]);

  // 폼 값들을 watch로 감지
  const watchedValues = watch();

  // 코인 계산 API 호출 함수
  const callCalculateCoin = () => {
    if (!existingReserveData) return;

    // 선택된 반려동물 찾기
    const selectedPet = petList?.find(
      (pet: PetDataType) => pet.petSeq.toString() === selectedPetSeq
    );
    if (!selectedPet) return;
    console.log(watchedValues.startHour);
    // 요청 데이터 구성
    const requestData = {
      reservationSeq: existingReserveData.data.reservationSeq,
      cdProductType: cdProductType,
      gradeConfirm: existingReserveData.data.gradeConfirm,
      paymentCoinTotal: existingReserveData.data.paymentCoinTotal,
      companySeq: existingReserveData.data.companySeq,
      reserveForm: {
        productSeq: existingReserveData.data.reserveForm.productSeq, // 기본값 설정
        dtReservStart: watchedValues.startDate
          ? formatDate(watchedValues.startDate)
          : null,
        dtReservEnd: watchedValues.startDate
          ? formatDate(watchedValues.startDate)
          : null,
        endTime: watchedValues.endHour?.value
          ? watchedValues.endHour.value +
            ":" +
            watchedValues.endMinute?.value +
            ":00"
          : null,
        startTime: watchedValues.startHour?.value
          ? watchedValues.startHour.value +
            ":" +
            watchedValues.startMinute?.value +
            ":00"
          : null,
        // dayOfWeeks: [
        //   { cdDayOfWeek: "MONDAY", dayOfWeekName: "월요일", select: false },
        //   { cdDayOfWeek: "TUESDAY", dayOfWeekName: "화요일", select: false },
        //   { cdDayOfWeek: "WEDNESDAY", dayOfWeekName: "수요일", select: false },
        //   { cdDayOfWeek: "THURSDAY", dayOfWeekName: "목요일", select: false },
        //   { cdDayOfWeek: "FRIDAY", dayOfWeekName: "금요일", select: false },
        //   { cdDayOfWeek: "SATURDAY", dayOfWeekName: "토요일", select: false },
        //   { cdDayOfWeek: "SUNDAY", dayOfWeekName: "일요일", select: false },
        // ],
        paymentCoin: existingReserveData.data.reserveForm.paymentCoin, // 기본값 설정
        additionals: existingReserveData.data.reserveForm.additionals.map(
          (additional: {
            additionalCompanySeq?: number;
            additionalName: string;
            paymentCoin: number;
          }) => ({
            ...additional,
            active: true, // 기본값 설정
            select:
              watchedValues.services?.includes(
                additional.additionalCompanySeq?.toString() || ""
              ) || false,
          })
        ),
        pets: existingReserveData.data.reserveForm.pets,
        memo: null,
      },
    };

    console.log("코인 계산 API 호출:", requestData);
    calculateCoin(requestData);
  };

  // 조건에 따라 코인 계산 API 호출
  useEffect(() => {
    // 1. 날짜를 선택했을 때
    // 2. 시간을 선택했을 때 (시, 분)
    // 3. 부가서비스를 선택했을 때
    // 4. 반려동물을 선택했을 때

    const hasDate = watchedValues.startDate;
    const hasTime =
      watchedValues.startHour &&
      watchedValues.startMinute &&
      watchedValues.endHour &&
      watchedValues.endMinute;
    const hasPetSelected = selectedPetSeq;

    if (hasDate && hasTime && hasPetSelected && existingReserveData) {
      callCalculateCoin();
    }
  }, [
    watchedValues.startDate,
    watchedValues.startHour,
    watchedValues.startMinute,
    watchedValues.endHour,
    watchedValues.endMinute,
    watchedValues.services,
    selectedPetSeq,
    existingReserveData,
  ]);

  // const handleDateClick = () => {
  //   if (!isUpdatable) return;
  //   clickModal();
  // };

  const handleDaySelect = (day: Date | null) => {
    if (!day || !isUpdatable) return; // 수정 불가능한 경우 무시

    const formattedDate = formatDate(day);

    // 데이케어는 시작일과 종료일이 같음
    setValue("startDate", formattedDate, { shouldValidate: true });
    setStartDate(day);
  };

  // const bindSubmit = (data: ReservationClassState) => {
  //   console.log("예약 데이터:", data);

  //   if (!existingReserveData) {
  //     console.error("필수 데이터가 없습니다.");
  //     return;
  //   }

  //   // gradeConfirm 체크
  //   if (!existingReserveData.data.gradeConfirm) {
  //     console.error("해당 반려견의 체급은 수용이 불가능합니다.");
  //     setShowGradeConfirmDialog(true);
  //     return;
  //   }

  //   // 코인 잔액 확인
  //   if (isCheckingBalance) {
  //     console.log("코인 잔액 확인 중...");
  //     return;
  //   }

  //   if (hasBalanceCoinData) {
  //     console.log("코인 잔액 확인 결과:", hasBalanceCoinData);

  //     // 코인 잔액이 부족한 경우 처리
  //     if (!hasBalanceCoinData.data.coinPurchasable) {
  //       console.error("코인 잔액이 부족합니다.");
  //       setShowCoinShortageDialog(true);
  //       return;
  //     }
  //   }
  //   // // 선택된 반려동물 찾기
  //   // const selectedPet = petList?.find(
  //   //   (pet: PetDataType) => pet.petSeq.toString() === selectedPetSeq
  //   // );
  //   // console.log(selectedPet);
  //   // if (!selectedPet) {
  //   //   console.error("선택된 반려동물을 찾을 수 없습니다.");
  //   //   return;
  //   // }

  //   // 예약 생성 요청 데이터 구성
  //   const requestData: any = {
  //     reservationSeq: initialReservationSeq || 0,
  //     cdProductType: cdProductType,
  //     gradeConfirm: existingReserveData.data.gradeConfirm,
  //     paymentCoinTotal: calculateCoinData?.data?.paymentCoinTotal || null,
  //     companySeq: existingReserveData.data.companySeq,
  //     reserveForm: {
  //       productSeq: existingReserveData.data.reserveForm.productSeq,
  //       dtReservStart: data.startDate
  //         ? formatDate(new Date(data.startDate))
  //         : null,
  //       dtReservEnd: data.startDate
  //         ? formatDate(new Date(data.startDate))
  //         : null,
  //       startTime:
  //         data.startHour?.value && data.startMinute?.value
  //           ? data.startHour.value + ":" + data.startMinute.value + ":00"
  //           : null,
  //       endTime:
  //         data.endHour?.value && data.endMinute?.value
  //           ? data.endHour.value + ":" + data.endMinute.value + ":00"
  //           : null,
  //       dayOfWeeks: [], // 데이케어는 요일 선택이 없음
  //       paymentCoin: existingReserveData.data.reserveForm.paymentCoin,
  //       additionals: existingReserveData.data.reserveForm.additionals.map(
  //         (additional: {
  //           additionalCompanySeq?: number;
  //           additionalName: string;
  //           paymentCoin: number;
  //         }) => ({
  //           ...additional,
  //           active: true,
  //           select:
  //             data.services?.includes(
  //               additional.additionalCompanySeq?.toString() || ""
  //             ) || false,
  //         })
  //       ),
  //       pets: existingReserveData.data.reserveForm.pets,
  //       memo: null,
  //     },
  //   };

  //   console.log("예약 생성 API 호출:", requestData);

  //   updateReserve(requestData, {
  //     onSuccess: (response: any) => {
  //       console.log("예약 생성 응답:", response);
  //       if (response.statusCode === 200) {
  //         // responseCode 확인
  //         if (response.data?.responseCode === "DAYCARE_RESERVE_REQUESTED") {
  //           // 예약 성공 시 update-temp API 호출
  //           // if (response.data?.reservationSeq) {
  //           //   updateTempReserve({
  //           //     reservationSeq: response.data.reservationSeq,
  //           //     contractCancel: false,
  //           //   });
  //           // }
  //           setShowReservationCompleteDialog(true);
  //         } else if (response.data?.responseCode === "INVALID_CONTRACT") {
  //           // 계약이 필요한 경우
  //           setReservationSeq(response.data?.reservationSeq || null);
  //           setContractMessage(response.message || "계약이 필요합니다.");
  //           setShowContractDialog(true);
  //         } else {
  //           // 정상 성공인 경우
  //           // alert("예약이 성공적으로 완료되었습니다.");
  //           // history.push("/reservation/success");
  //           setShowReservationCompleteDialog(true);
  //         }
  //       }
  //     },
  //     onError: (error: unknown) => {
  //       console.error("예약 생성 실패:", error);
  //       alert("예약 생성에 실패했습니다. 다시 시도해주세요.");
  //     },
  //   });
  // };

  // // 예약 취소 함수
  // const handleCancelReservation = () => {
  //   if (!initialReservationSeq) {
  //     console.error("예약 번호가 없습니다.");
  //     return;
  //   }

  //   cancelReserve(existingReserveData ? existingReserveData.data : {}, {
  //     onSuccess: (response: any) => {
  //       console.log("예약 취소 응답:", response);
  //       if (response.statusCode === 200) {
  //         setShowReservationCancelDialog(true);
  //       }
  //     },
  //     onError: (error: unknown) => {
  //       console.error("예약 취소 실패:", error);
  //       alert("예약 취소에 실패했습니다. 다시 시도해주세요.");
  //     },
  //   });
  // };

  // const services = [
  //   {
  //     id: "1",
  //     title: "등원 픽드롭",
  //     desc: "집으로 데리러 가요",
  //     price: "3멍코인",
  //   },
  //   {
  //     id: "2",
  //     title: "하원 픽드롭",
  //     desc: "집까지 데려다 줘요",
  //     price: "3멍코인",
  //   },
  //   {
  //     id: "3",
  //     title: "기본 케어 서비스",
  //     desc: "발톱, 털정리 등",
  //     price: "3멍코인",
  //   },
  // ];

  if (!existingReserveData?.data) {
    return (
      <div className="flex justify-center items-center py-20">
        <div className="text-gray-500">예약 정보를 불러오는 중...</div>
      </div>
    );
  }

  const reserveData = existingReserveData.data;
  const reserveForm = reserveData.reserveForm;
  const isCanceled = reserveData.cdReservStatus === "RESERV_STATUS_CANCELED";
  const selectedAdditionals = (reserveForm.additionals || []).filter(
    (a) => a.select
  );
  const memoText = (reserveForm.memo || "").trim();
  const hasMemo = memoText.length > 0;
  const ticketInfo = reserveData.ticketInfo;

  // 잔여 회수
  const hasTicketQty =
    !!ticketInfo &&
    typeof ticketInfo.totalQty === "number" &&
    typeof ticketInfo.remainQty === "number";
  const usedQty = hasTicketQty
    ? (ticketInfo!.totalQty as number) - (ticketInfo!.remainQty as number)
    : 0;
  const remainQty = hasTicketQty ? (ticketInfo!.remainQty as number) : 0;

  // 시간 칩
  const selectedTimeNames = (reserveForm.times || [])
    .filter((t) => t.select)
    .map((t) => t.timeName);

  // 선택된 반려동물
  const selectedPet = petList?.find(
    (pet: PetDataType) => pet.petSeq.toString() === selectedPetSeq
  );

  // 날짜 포맷팅
  const formatDisplayDate = (date: Date | null) => {
    if (!date) return "";
    return date.toLocaleDateString("ko-KR", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
  };

  // 예약 유형 한글 라벨
  const reservationTypeLabel = (() => {
    switch (storeType) {
      case "RESERV_TYPE_CLASS":
        return "유치원";
      case "RESERV_TYPE_DAYCARE":
        return "데이케어";
      case "RESERV_TYPE_HOTEL":
        return "호텔";
      case "RESERV_TYPE_GROOMING":
        return "미용";
      default:
        return "";
    }
  })();

  // 공용 카드 스타일
  const cardClass =
    "p-4 bg-white rounded-2xl border border-orange-100 shadow-[0_1px_2px_rgba(0,0,0,0.04)]";
  const titleClass =
    "mb-2 text-[11px] font-bold tracking-[0.08em] text-orange-500 uppercase";

  const Section = ({
    title,
    children,
    headerSlot,
  }: {
    title: string;
    children: ReactNode;
    headerSlot?: ReactNode;
  }) => (
    <section className={cardClass}>
      {headerSlot ? (
        <div className="flex justify-between items-center">
          <h3 className={titleClass}>{title}</h3>
          {headerSlot}
        </div>
      ) : (
        <h3 className={titleClass}>{title}</h3>
      )}
      {children}
    </section>
  );

  return (
    <>
      <div className="flex flex-col gap-2.5 pb-4">
        {/* 0. 취소된 예약 안내 — 취소돼도 예약했던 날짜·시간을 확인할 수 있게 상세는 그대로 보여준다 */}
        {isCanceled && (
          <div className="flex gap-2.5 items-start p-4 bg-gray-100 rounded-2xl border border-gray-200">
            <span className="flex-shrink-0 px-2.5 py-0.5 text-[11px] font-semibold text-gray-600 bg-white rounded-full border border-gray-300">
              예약취소
            </span>
            <p className="text-sm leading-relaxed text-gray-600 break-keep">
              취소된 예약이에요. 아래 내용은 취소 전 예약했던 정보예요.
            </p>
          </div>
        )}
        {/* 1. 반려동물 */}
        {selectedPet && (
          <Section title="반려동물">
            <div className="flex gap-3 items-center">
              <div className="flex-shrink-0">
                {selectedPet.fileUrl ? (
                  <img
                    src={selectedPet.fileUrl}
                    alt={selectedPet.petName || ""}
                    className="object-cover w-14 h-14 rounded-full border border-orange-100"
                  />
                ) : (
                  <div className="flex justify-center items-center w-14 h-14 bg-orange-50 rounded-full">
                    <svg
                      className="w-7 h-7 text-orange-300"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                      />
                    </svg>
                  </div>
                )}
              </div>
              <div className="flex-1 min-w-0">
                <div className="text-base font-semibold text-gray-900 truncate">
                  {selectedPet.petName}
                </div>
                <div className="flex flex-wrap gap-x-2 gap-y-0.5 mt-0.5 text-xs text-gray-500">
                  {selectedPet.petBreedName && (
                    <span>{selectedPet.petBreedName}</span>
                  )}
                  {selectedPet.petBreedName && selectedPet.petWeight ? (
                    <span className="text-gray-300">·</span>
                  ) : null}
                  {selectedPet.petWeight ? (
                    <span>{selectedPet.petWeight}kg</span>
                  ) : null}
                </div>
              </div>
            </div>
          </Section>
        )}

        {/* 2. 이용 업체 */}
        <Section
          title="이용 업체"
          headerSlot={
            reservationTypeLabel ? (
              <span className="px-2.5 py-0.5 text-[11px] font-semibold text-orange-600 bg-orange-50 rounded-full">
                {reservationTypeLabel}
              </span>
            ) : undefined
          }
        >
          <div className="mt-0.5">
            <div className="text-base font-semibold text-gray-900 break-keep">
              {storeName || ticketInfo?.companyName || "-"}
            </div>
            {ticketInfo?.address && (
              <div className="mt-1 text-xs leading-relaxed text-gray-500 break-keep">
                {ticketInfo.address}
              </div>
            )}
          </div>
        </Section>

        {/* 3. 예약 일정 */}
        <Section title="예약 일정">
          <div className="text-lg font-bold leading-tight text-gray-900">
            {formatDisplayDate(startDate)}
          </div>
          {selectedTimeNames.length > 0 && (
            <div className="flex flex-wrap gap-1.5 mt-3">
              {selectedTimeNames.map((name) => (
                <span
                  key={name}
                  className="px-2.5 py-1 text-xs font-medium text-orange-600 bg-orange-50 rounded-full"
                >
                  {name}
                </span>
              ))}
            </div>
          )}
        </Section>

        {/* 4. 사용 이용권 */}
        {ticketInfo && (
          <Section title="사용 이용권">
            <div className="flex gap-3 justify-between items-start">
              <div className="flex-1 min-w-0">
                <div className="text-base font-semibold leading-tight text-gray-900 break-keep">
                  {ticketInfo.name}
                </div>
                {ticketInfo.badge && ticketInfo.badge.length > 0 && (
                  <div className="flex flex-wrap gap-1 mt-1.5">
                    {ticketInfo.badge.map((badge: string, idx: number) => (
                      <span
                        key={idx}
                        className="px-2 py-0.5 text-[11px] font-medium text-orange-600 bg-orange-50 rounded-full"
                      >
                        {badge}
                      </span>
                    ))}
                  </div>
                )}
              </div>
              {typeof ticketInfo.amount === "number" && (
                <div className="flex-shrink-0 text-right">
                  <div className="text-[11px] text-gray-500">결제 금액</div>
                  <div className="text-base font-bold text-orange-600">
                    {ticketInfo.amount.toLocaleString()}
                    <span className="ml-0.5 text-xs font-medium text-orange-500">
                      원
                    </span>
                  </div>
                </div>
              )}
            </div>

            {(hasTicketQty || ticketInfo.expiredDate) && (
              <div className="grid grid-cols-2 gap-3 pt-3 mt-3 border-t border-gray-100">
                {hasTicketQty && (
                  <div>
                    <div className="text-[11px] text-gray-500">사용 현황</div>
                    <div className="mt-0.5 text-sm font-semibold text-gray-800">
                      <span>{usedQty}회 사용</span>
                      <span
                        className={
                          remainQty === 0
                            ? "ml-1 font-normal text-gray-400"
                            : "ml-1 text-orange-500"
                        }
                      >
                        ({remainQty}회 남음)
                      </span>
                    </div>
                  </div>
                )}
                {ticketInfo.expiredDate && (
                  <div className={hasTicketQty ? "text-right" : ""}>
                    <div className="text-[11px] text-gray-500">만료일</div>
                    <div className="mt-0.5 text-sm font-semibold text-gray-800">
                      {ticketInfo.expiredDate}
                    </div>
                  </div>
                )}
              </div>
            )}
          </Section>
        )}

        {/* (옵션) 부가 서비스 */}
        {selectedAdditionals.length > 0 && (
          <Section title="부가 서비스">
            <ul className="divide-y divide-gray-100">
              {selectedAdditionals.map((item) => (
                <li
                  key={item.additionalCompanySeq}
                  className="flex justify-between items-center py-2"
                >
                  <span className="text-sm text-gray-800">
                    {item.additionalName}
                  </span>
                  {typeof item.paymentCoin === "number" &&
                    item.paymentCoin > 0 && (
                      <span className="text-xs font-medium text-gray-500">
                        {item.paymentCoin.toLocaleString()} 멍코인
                      </span>
                    )}
                </li>
              ))}
            </ul>
          </Section>
        )}

        {/* (옵션) 메모 */}
        {hasMemo && (
          <Section title="메모">
            <p className="text-sm leading-relaxed text-gray-700 whitespace-pre-wrap break-keep">
              {memoText}
            </p>
          </Section>
        )}
      </div>
      <Divider className="mt-auto" line />
      {/* 하단 확인 버튼 */}
      <div className="w-full px-4 py-4 bg-[#F5F5F5]">
        <button
          onClick={() => history.back()}
          className="py-3 w-full text-base font-semibold text-center text-white bg-orange-400 rounded-full"
        >
          확인
        </button>
      </div>
      {/* <div className="flex justify-between pt-5 pb-3 text-[#999] text-[13px] leading-[16.9px] ">
        예약정보는 예약일 1일 전까지만 수정 및 취소 할 수 있습니다. 예약 당일
        서비스 미 이용 시에도 이용권은 자동으로 소진됩니다.예약 확정은
        위탁사업자 확인 후 이루어집니다.
      </div>
      <div className="flex justify-end mt-2 mr-2">
        <Controller
          name="agree"
          control={control}
          rules={{ required: "확인 및 동의가 필요합니다." }}
          render={({ field }) => (
            <ValidateCheckbox
              defaultChecked={field.value}
              onChange={() => field.onChange(!field.value)}
              disabled={!isUpdatable}
              title="확인 및 동의"
            />
          )}
        />
      </div> */}
      {/* {isUpdatable && (
        <div className="w-full px-2 pb-6 bg-[#F5F5F5] pt-10 grid grid-cols-1 gap-5">
          <Button
            className="w-full bg-[#F5F5F5]"
            style={{ pointerEvents: "auto" }}
            onClick={handleSubmit(bindSubmit)}
            disabled={!isValid || isUpdating || !isUpdatable}
          >
            <div className="py-3 mx-auto w-full text-base font-semibold text-center text-white bg-orange-400 rounded-full">
              {calculateCoinData?.data?.coinDiff
                ? calculateCoinData?.data?.coinDiff +
                  "멍코인 결제 후 예약 정보 수정"
                : "예약 정보 수정"}
            </div>
          </Button>
          <Button
            className="w-full bg-[#F5F5F5]"
            style={{ pointerEvents: "auto" }}
            onClick={handleCancelReservation}
            disabled={!isValid || isCanceling || !isUpdatable}
          >
            <div className="py-3 mx-auto w-full text-base font-semibold text-center text-orange-400 bg-white rounded-full border border-orange-400">
              {isCanceling ? "취소 중..." : "예약 취소"}
            </div>
          </Button>
        </div>
      )}
      {!isUpdatable && (
        <div className="w-full px-2 pb-6 bg-[#F5F5F5] pt-10 grid grid-cols-1 gap-5">
          <Button
            className="w-full bg-[#F5F5F5]"
            style={{ pointerEvents: "auto" }}
            onClick={handleSubmit(bindSubmit)}
            disabled={true}
          >
            <div className="py-3 mx-auto w-full text-base font-semibold text-center text-white bg-[#999] rounded-full">
              예약 정보 수정 불가
            </div>
          </Button>
          <Button
            className="w-full bg-[#F5F5F5]"
            style={{ pointerEvents: "auto" }}
            onClick={handleSubmit(bindSubmit)}
            disabled={true}
          >
            <div className="py-3 mx-auto w-full text-base font-semibold text-center text-[#999] bg-white rounded-full border border-[#999]">
              예약 취소 불가
            </div>
          </Button>
        </div>
      )} */}

      {/* 달력 모달 */}
      <MessageModal
        isOpen={isOpenModal}
        onRequestClose={closeModal}
        className="pt-0 pb-6 mx-auto w-full max-w-sm bg-white rounded-2xl border-2 border-gray-200 shadow-lg outline-none"
        overlayClassName="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50"
        shouldCloseOnOverlayClick={false}
      >
        <CalendarComponent
          disabled={false}
          dayOnClick={(day) => {
            handleDaySelect(day);
          }}
          selectedDay={startDate}
          schedules={{}}
        />
        <div className="flex gap-3 mt-2">
          <button
            className="flex-1 py-2 font-semibold text-gray-700 bg-gray-200 rounded-full border border-gray-300"
            onClick={closeModal}
          >
            취소
          </button>
          <button
            className="flex-1 py-2 font-semibold text-white bg-orange-400 rounded-full"
            onClick={closeModal}
          >
            확인
          </button>
        </div>
      </MessageModal>
      {/* 달력 모달 */}

      {/* 계약 관련 다이얼로그 */}
      <Dialog
        visible={showContractDialog}
        onClose={() => {
          setShowContractDialog(false);
          // onClose 이벤트 시 updateTempReserve 호출
          if (reservationSeq) {
            updateTempReserve({
              reservationSeq,
              contractCancel: true,
            });
          }
        }}
      >
        <div className="p-4">
          <p className="mb-4 text-center">{contractMessage}</p>
          <div className="flex gap-2">
            <button
              className="flex-1 py-2 font-semibold text-gray-700 bg-gray-200 rounded-full border border-gray-300"
              onClick={() => {
                setShowContractDialog(false);
                // 취소 버튼 클릭 시 updateTempReserve 호출
                if (reservationSeq) {
                  updateTempReserve({
                    reservationSeq,
                    contractCancel: true,
                  });
                }
              }}
            >
              취소
            </button>
            <button
              className="flex-1 py-2 font-semibold text-white bg-orange-400 rounded-full"
              onClick={() => {
                setShowContractDialog(false);
                setShowContractModal(true);
              }}
            >
              확인
            </button>
          </div>
        </div>
      </Dialog>

      {/* 계약 모달 */}
      <ContractModal
        visible={showContractModal}
        onClose={() => setShowContractModal(false)}
        onConfirm={() => {
          updateTempReserve({
            reservationSeq: reservationSeq || 0,
            contractCancel: false,
          });
          setShowContractModal(false);
          setShowReservationCompleteDialog(true);
        }}
        selectedPet={petList?.find(
          (pet) => pet.petSeq.toString() === selectedPetSeq
        )}
        reservationSeq={reservationSeq || undefined}
        companySeq={parseInt(storeData.value)}
        // userSeq={1} // TODO: 실제 사용자 정보에서 가져오기
      />

      {/* 체급 확인 다이얼로그 */}
      <Dialog
        visible={showGradeConfirmDialog}
        onClose={() => setShowGradeConfirmDialog(false)}
      >
        <div className="p-6 text-center">
          <h3 className="mb-4 text-lg font-bold">체급 수용 불가</h3>
          <p className="mb-6 text-sm text-gray-600">
            해당 반려견의 체급은 수용이 불가능합니다.
          </p>
          <div className="flex justify-center">
            <button
              className="px-8 py-3 font-semibold text-white bg-orange-400 rounded-lg w-ful"
              onClick={() => setShowGradeConfirmDialog(false)}
            >
              확인
            </button>
          </div>
        </div>
      </Dialog>

      {/* 코인 부족 다이얼로그 */}
      <Dialog
        visible={showCoinShortageDialog}
        onClose={() => setShowCoinShortageDialog(false)}
      >
        <div className="p-6 text-center">
          <h3 className="mb-4 text-lg font-bold">멍코인이 모자라요</h3>
          <p className="mb-6 text-sm text-gray-600">
            멍코인 구매 페이지로 이동합니다.
          </p>
          <div className="flex gap-3">
            <button
              className="flex-1 py-2 font-semibold text-gray-700 bg-gray-200 rounded-full border border-gray-300"
              onClick={() => setShowCoinShortageDialog(false)}
            >
              취소
            </button>
            <button
              className="flex-1 py-2 font-semibold text-white bg-orange-400 rounded-lg"
              onClick={() => {
                setShowCoinShortageDialog(false);
                history.push("/customer/layout/user-buy-coin");
              }}
            >
              확인
            </button>
          </div>
        </div>
      </Dialog>

      {/* 예약 완료 다이얼로그 */}
      <Dialog
        visible={showReservationCompleteDialog}
        onClose={() => setShowReservationCompleteDialog(false)}
      >
        <div className="p-6 text-center">
          <h3 className="mb-4 text-lg font-bold">예약 정보 수정 완료</h3>
          <div className="p-3 mb-4 bg-gray-100 rounded-full bg-[#F5F5F5] max-w-[200px] mx-auto">
            <span className="font-bold text-black">
              {startDate
                ? startDate
                    .toLocaleDateString("ko-KR", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                    })
                    .replace(/\. /g, ".")
                : new Date()
                    .toLocaleDateString("ko-KR", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                    })
                    .replace(/\. /g, ".")}
            </span>
          </div>
          <p className="mb-6 text-sm text-gray-600">
            데이케어 예약의 정보가 변경되었습니다.
          </p>
          <div className="flex justify-center">
            <button
              className="px-8 py-3 font-semibold text-white bg-orange-400 rounded-lg"
              onClick={() => {
                setShowReservationCompleteDialog(false);
                history.push("/customer/layout/calendar");
              }}
            >
              확인
            </button>
          </div>
        </div>
      </Dialog>
      <Dialog
        visible={showReservationCancelDialog}
        onClose={() => setShowReservationCancelDialog(false)}
      >
        <div className="p-6 text-center">
          <h3 className="mb-4 text-lg font-bold">예약 취소 완료</h3>
          <div className="p-3 mb-4 bg-gray-100 rounded-full bg-[#F5F5F5] max-w-[200px] mx-auto">
            <span className="font-bold text-black">
              {startDate
                ? startDate
                    .toLocaleDateString("ko-KR", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                    })
                    .replace(/\. /g, ".")
                : new Date()
                    .toLocaleDateString("ko-KR", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                    })
                    .replace(/\. /g, ".")}
            </span>
          </div>
          <p className="mb-6 text-sm text-gray-600">
            데이케어 예약이 취소되었습니다.
          </p>
          <div className="flex justify-center">
            <button
              className="px-8 py-3 font-semibold text-white bg-orange-400 rounded-lg"
              onClick={() => {
                setShowReservationCancelDialog(false);
                history.push("/customer/layout/calendar");
              }}
            >
              확인
            </button>
          </div>
        </div>
      </Dialog>
    </>
  );
};
export default ReservationChgDaycare;
